import { render, staticRenderFns } from "./AnncmntDrawer.vue?vue&type=template&id=63b39d83&scoped=true"
import script from "./AnncmntDrawer.vue?vue&type=script&lang=js"
export * from "./AnncmntDrawer.vue?vue&type=script&lang=js"
import style0 from "./AnncmntDrawer.vue?vue&type=style&index=0&id=63b39d83&prod&lang=scss&scoped=true"
import style1 from "./AnncmntDrawer.vue?vue&type=style&index=1&id=63b39d83&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b39d83",
  null
  
)

export default component.exports